import {
  Companion_getInstance3r9dph6rgwho0 as Companion_getInstance,
  ContractorDocument2jcw9hqg98amj as ContractorDocument,
  Purpose_Other_getInstancerlegdjt2kagb as Purpose_Other_getInstance,
  Purpose22kmyfd0ayrve as Purpose,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.prop(ContractorDocument_name_getInstance());
}
function get_fileType(_this__u8e3s4) {
  return _this__u8e3s4.prop(ContractorDocument_fileType_getInstance());
}
function get_file(_this__u8e3s4) {
  return _this__u8e3s4.prop(ContractorDocument_file_getInstance());
}
function get_preview(_this__u8e3s4) {
  return _this__u8e3s4.prop(ContractorDocument_preview_getInstance());
}
function get_contractor(_this__u8e3s4) {
  return _this__u8e3s4.prop(ContractorDocument_contractor_getInstance());
}
function prepareContractorDocumentFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ContractorDocument__id_getInstance(), ContractorDocument_contractor_getInstance(), ContractorDocument_name_getInstance(), ContractorDocument_fileType_getInstance(), ContractorDocument_file_getInstance(), ContractorDocument_preview_getInstance(), ContractorDocument_purpose_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ContractorDocument_name$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ContractorDocument_name$_get_name_$ref_jwz5bb() {
  return (p0) => p0.k20();
}
function ContractorDocument_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorDocument_name$_get_serializer_$ref_vfgs5q() {
  return (p0) => p0.j2j();
}
function ContractorDocument_name$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ContractorDocument_name$_get_annotations_$ref_40fg7m() {
  return (p0) => p0.bz();
}
var ContractorDocument_nameClass;
function ContractorDocument_name() {
  if (ContractorDocument_nameClass === VOID) {
    class $ {
      constructor() {
        ContractorDocument_name_instance = this;
        var tmp = this;
        tmp.z5g_1 = lazy(ContractorDocument_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a5h_1 = lazy(ContractorDocument_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b5h_1 = lazy(ContractorDocument_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.z5g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorDocument_name$_get_name_$ref_jwz5bb(), null);
        return tmp0.f2();
      }
      c5h(receiver) {
        return receiver.f5h_1;
      }
      m2j(receiver) {
        return this.c5h(receiver instanceof ContractorDocument() ? receiver : THROW_CCE());
      }
      k5h(receiver, value) {
        return receiver.l5h(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorDocument() ? receiver : THROW_CCE();
        return this.k5h(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorDocument_name$_get_serializer_$ref_vfgs5q(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorDocument_name$_get_annotations_$ref_40fg7m(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorDocument_name', VOID, VOID, [SerializableProperty()]);
    ContractorDocument_nameClass = $;
  }
  return ContractorDocument_nameClass;
}
var ContractorDocument_name_instance;
function ContractorDocument_name_getInstance() {
  if (ContractorDocument_name_instance === VOID)
    new (ContractorDocument_name())();
  return ContractorDocument_name_instance;
}
function ContractorDocument_fileType$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ContractorDocument_fileType$_get_name_$ref_udhir2() {
  return (p0) => p0.k20();
}
function ContractorDocument_fileType$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorDocument_fileType$_get_serializer_$ref_rmqid5() {
  return (p0) => p0.j2j();
}
function ContractorDocument_fileType$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ContractorDocument_fileType$_get_annotations_$ref_kb684j() {
  return (p0) => p0.bz();
}
var ContractorDocument_fileTypeClass;
function ContractorDocument_fileType() {
  if (ContractorDocument_fileTypeClass === VOID) {
    class $ {
      constructor() {
        ContractorDocument_fileType_instance = this;
        var tmp = this;
        tmp.m5h_1 = lazy(ContractorDocument_fileType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n5h_1 = lazy(ContractorDocument_fileType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o5h_1 = lazy(ContractorDocument_fileType$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.m5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorDocument_fileType$_get_name_$ref_udhir2(), null);
        return tmp0.f2();
      }
      c5h(receiver) {
        return receiver.g5h_1;
      }
      m2j(receiver) {
        return this.c5h(receiver instanceof ContractorDocument() ? receiver : THROW_CCE());
      }
      k5h(receiver, value) {
        return receiver.l5h(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorDocument() ? receiver : THROW_CCE();
        return this.k5h(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorDocument_fileType$_get_serializer_$ref_rmqid5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorDocument_fileType$_get_annotations_$ref_kb684j(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorDocument_fileType', VOID, VOID, [SerializableProperty()]);
    ContractorDocument_fileTypeClass = $;
  }
  return ContractorDocument_fileTypeClass;
}
var ContractorDocument_fileType_instance;
function ContractorDocument_fileType_getInstance() {
  if (ContractorDocument_fileType_instance === VOID)
    new (ContractorDocument_fileType())();
  return ContractorDocument_fileType_instance;
}
function ContractorDocument_file$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ContractorDocument_file$_get_name_$ref_8jkpxk() {
  return (p0) => p0.k20();
}
function ContractorDocument_file$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorDocument_file$_get_serializer_$ref_uodgh() {
  return (p0) => p0.j2j();
}
function ContractorDocument_file$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ContractorDocument_file$_get_annotations_$ref_abaio3() {
  return (p0) => p0.bz();
}
var ContractorDocument_fileClass;
function ContractorDocument_file() {
  if (ContractorDocument_fileClass === VOID) {
    class $ {
      constructor() {
        ContractorDocument_file_instance = this;
        var tmp = this;
        tmp.p5h_1 = lazy(ContractorDocument_file$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q5h_1 = lazy(ContractorDocument_file$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r5h_1 = lazy(ContractorDocument_file$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.p5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorDocument_file$_get_name_$ref_8jkpxk(), null);
        return tmp0.f2();
      }
      s5h(receiver) {
        return receiver.h5h_1;
      }
      m2j(receiver) {
        return new (ServerFile())(this.s5h(receiver instanceof ContractorDocument() ? receiver : THROW_CCE()));
      }
      t5h(receiver, value) {
        return receiver.l5h(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorDocument() ? receiver : THROW_CCE();
        return this.t5h(tmp, value instanceof ServerFile() ? value.n2n_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorDocument_file$_get_serializer_$ref_uodgh(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorDocument_file$_get_annotations_$ref_abaio3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorDocument_file', VOID, VOID, [SerializableProperty()]);
    ContractorDocument_fileClass = $;
  }
  return ContractorDocument_fileClass;
}
var ContractorDocument_file_instance;
function ContractorDocument_file_getInstance() {
  if (ContractorDocument_file_instance === VOID)
    new (ContractorDocument_file())();
  return ContractorDocument_file_instance;
}
function ContractorDocument_preview$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ContractorDocument_preview$_get_name_$ref_jsumka() {
  return (p0) => p0.k20();
}
function ContractorDocument_preview$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorDocument_preview$_get_serializer_$ref_o9w4t() {
  return (p0) => p0.j2j();
}
function ContractorDocument_preview$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ContractorDocument_preview$_get_annotations_$ref_y0wbbl() {
  return (p0) => p0.bz();
}
var ContractorDocument_previewClass;
function ContractorDocument_preview() {
  if (ContractorDocument_previewClass === VOID) {
    class $ {
      constructor() {
        ContractorDocument_preview_instance = this;
        var tmp = this;
        tmp.u5h_1 = lazy(ContractorDocument_preview$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v5h_1 = lazy(ContractorDocument_preview$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w5h_1 = lazy(ContractorDocument_preview$annotations$delegate$lambda);
        this.x5h_1 = null;
        this.y5h_1 = 'null';
      }
      k20() {
        var tmp0 = this.u5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorDocument_preview$_get_name_$ref_jsumka(), null);
        return tmp0.f2();
      }
      z5h(receiver) {
        return receiver.i5h_1;
      }
      m2j(receiver) {
        var tmp = this.z5h(receiver instanceof ContractorDocument() ? receiver : THROW_CCE());
        return tmp == null ? null : new (ServerFile())(tmp);
      }
      a5i(receiver, value) {
        return receiver.l5h(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorDocument() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof ServerFile()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.n2n_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.a5i(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.v5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorDocument_preview$_get_serializer_$ref_o9w4t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w5h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorDocument_preview$_get_annotations_$ref_y0wbbl(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorDocument_preview', VOID, VOID, [SerializableProperty()]);
    ContractorDocument_previewClass = $;
  }
  return ContractorDocument_previewClass;
}
var ContractorDocument_preview_instance;
function ContractorDocument_preview_getInstance() {
  if (ContractorDocument_preview_instance === VOID)
    new (ContractorDocument_preview())();
  return ContractorDocument_preview_instance;
}
function ContractorDocument_contractor$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ContractorDocument_contractor$_get_name_$ref_omchw1() {
  return (p0) => p0.k20();
}
function ContractorDocument_contractor$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorDocument_contractor$_get_serializer_$ref_79oago() {
  return (p0) => p0.j2j();
}
function ContractorDocument_contractor$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ContractorDocument_contractor$_get_annotations_$ref_sc9wxw() {
  return (p0) => p0.bz();
}
var ContractorDocument_contractorClass;
function ContractorDocument_contractor() {
  if (ContractorDocument_contractorClass === VOID) {
    class $ {
      constructor() {
        ContractorDocument_contractor_instance = this;
        var tmp = this;
        tmp.b5i_1 = lazy(ContractorDocument_contractor$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5i_1 = lazy(ContractorDocument_contractor$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5i_1 = lazy(ContractorDocument_contractor$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.b5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorDocument_contractor$_get_name_$ref_omchw1(), null);
        return tmp0.f2();
      }
      c5h(receiver) {
        return receiver.e5h_1;
      }
      m2j(receiver) {
        return this.c5h(receiver instanceof ContractorDocument() ? receiver : THROW_CCE());
      }
      e5i(receiver, value) {
        return receiver.l5h(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorDocument() ? receiver : THROW_CCE();
        return this.e5i(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorDocument_contractor$_get_serializer_$ref_79oago(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorDocument_contractor$_get_annotations_$ref_sc9wxw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorDocument_contractor', VOID, VOID, [SerializableProperty()]);
    ContractorDocument_contractorClass = $;
  }
  return ContractorDocument_contractorClass;
}
var ContractorDocument_contractor_instance;
function ContractorDocument_contractor_getInstance() {
  if (ContractorDocument_contractor_instance === VOID)
    new (ContractorDocument_contractor())();
  return ContractorDocument_contractor_instance;
}
function ContractorDocument__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ContractorDocument__id$_get_name_$ref_l2ey9k() {
  return (p0) => p0.k20();
}
function ContractorDocument__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorDocument__id$_get_serializer_$ref_62a2ov() {
  return (p0) => p0.j2j();
}
function ContractorDocument__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ContractorDocument__id$_get_annotations_$ref_90ys03() {
  return (p0) => p0.bz();
}
var ContractorDocument__idClass;
function ContractorDocument__id() {
  if (ContractorDocument__idClass === VOID) {
    class $ {
      constructor() {
        ContractorDocument__id_instance = this;
        var tmp = this;
        tmp.f5i_1 = lazy(ContractorDocument__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g5i_1 = lazy(ContractorDocument__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h5i_1 = lazy(ContractorDocument__id$annotations$delegate$lambda);
        this.i5i_1 = Companion_getInstance_0().m2p();
        this.j5i_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.f5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorDocument__id$_get_name_$ref_l2ey9k(), null);
        return tmp0.f2();
      }
      c5h(receiver) {
        return receiver.d5h_1;
      }
      m2j(receiver) {
        return this.c5h(receiver instanceof ContractorDocument() ? receiver : THROW_CCE());
      }
      e5i(receiver, value) {
        return receiver.l5h(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorDocument() ? receiver : THROW_CCE();
        return this.e5i(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorDocument__id$_get_serializer_$ref_62a2ov(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorDocument__id$_get_annotations_$ref_90ys03(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorDocument__id', VOID, VOID, [SerializableProperty()]);
    ContractorDocument__idClass = $;
  }
  return ContractorDocument__idClass;
}
var ContractorDocument__id_instance;
function ContractorDocument__id_getInstance() {
  if (ContractorDocument__id_instance === VOID)
    new (ContractorDocument__id())();
  return ContractorDocument__id_instance;
}
function ContractorDocument_purpose$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function ContractorDocument_purpose$_get_name_$ref_xma0d8() {
  return (p0) => p0.k20();
}
function ContractorDocument_purpose$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ContractorDocument_purpose$_get_serializer_$ref_bl86t9() {
  return (p0) => p0.j2j();
}
function ContractorDocument_purpose$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function ContractorDocument_purpose$_get_annotations_$ref_bz7h7d() {
  return (p0) => p0.bz();
}
var ContractorDocument_purposeClass;
function ContractorDocument_purpose() {
  if (ContractorDocument_purposeClass === VOID) {
    class $ {
      constructor() {
        ContractorDocument_purpose_instance = this;
        var tmp = this;
        tmp.k5i_1 = lazy(ContractorDocument_purpose$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l5i_1 = lazy(ContractorDocument_purpose$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m5i_1 = lazy(ContractorDocument_purpose$annotations$delegate$lambda);
        this.n5i_1 = Purpose_Other_getInstance();
        this.o5i_1 = 'ContractorDocument.Purpose.Other';
      }
      k20() {
        var tmp0 = this.k5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ContractorDocument_purpose$_get_name_$ref_xma0d8(), null);
        return tmp0.f2();
      }
      c5h(receiver) {
        return receiver.j5h_1;
      }
      m2j(receiver) {
        return this.c5h(receiver instanceof ContractorDocument() ? receiver : THROW_CCE());
      }
      p5i(receiver, value) {
        return receiver.l5h(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ContractorDocument() ? receiver : THROW_CCE();
        return this.p5i(tmp, value instanceof Purpose() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ContractorDocument_purpose$_get_serializer_$ref_bl86t9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ContractorDocument_purpose$_get_annotations_$ref_bz7h7d(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ContractorDocument_purpose', VOID, VOID, [SerializableProperty()]);
    ContractorDocument_purposeClass = $;
  }
  return ContractorDocument_purposeClass;
}
var ContractorDocument_purpose_instance;
function ContractorDocument_purpose_getInstance() {
  if (ContractorDocument_purpose_instance === VOID)
    new (ContractorDocument_purpose())();
  return ContractorDocument_purpose_instance;
}
//region block: exports
export {
  get_contractor as get_contractor2z751sq639xj0,
  get_file as get_file3rh777rh5vwaj,
  get_fileType as get_fileType1vl9fun22hvs1,
  get_name as get_name70kb37c3pbx4,
  prepareContractorDocumentFields as prepareContractorDocumentFields3tjqhx4jsxti4,
  get_preview as get_preview1fun5m2mrxd65,
};
//endregion

//# sourceMappingURL=ContractorDocumentFields.mjs.map
